<template>
    <b-progress
        id="progress-secondary"
        animated
        v-bind="propRest"
        :value="value"
    />
</template>

<script>
export default {
    name: 'LoadingBar',
    props: {
        target: {
            type: Number,
            default: 0,
        },
        speed: {
            type: Number,
            default: 1,
        },
        frequency: {
            type: Number,
            default: 100,
        },
    },
    computed: {
        propRest() {
            const { target, speed, frequency, ...rest } = this._props;
            return rest;
        },
    },
    data: () => ({
        interval: null,
        value: 0,
    }),
    mounted() {
        this.interval = setInterval(() => {
            if (this.target > this.value) {
                this.value +=
                    this.target - this.value < this.speed
                        ? this.target - this.value
                        : this.speed;
            }
        }, this.frequency);
    },
    beforeDestroy() {
        clearInterval(this.interval);
        this.interval = null;
    },
    watch: {
        value(val) {
            if (val === 100) {
                this.$emit('hitmax');
            }
        },
    },
};
</script>
